<div class="loren-filters">
  @if(showSearch) {
  <form
    [formGroup]="searchForm"
    [ngClass]="{ 'loren-filters-header-number': withNumber }">
      @if (withNumber) {
          <div class="loren-filters-header-chosen">
              <span>{{ "selected_assets.selected" | transloco }}: </span>
              <b>{{ numOfChecked() }}</b> {{ "alarms.out_of" | transloco }} {{ withNumber }}
          </div>
      }
    <mat-form-field
      class="loren-form-field"
      appearance="outline">
      <input
        matInput
        type="text"
        [placeholder]="placeholder"
        formControlName="search" />
      <mat-icon matPrefix>search</mat-icon>
    </mat-form-field>
  </form>
  }
  <mat-divider></mat-divider>
    <div class="loren-filters-content">
        @for (item of filterItems(); track item) {
            <div>
                <mat-checkbox [checked]="selectionMap.get(item.value)"
                              [disabled]="
            withNumber &&
            numOfChecked() >= withNumber &&
            !selectionMap.get(item.value)
          "
                              (change)="updateSelection(item.value)">
                    {{ item.key }}

                </mat-checkbox>
            </div>
        }
    </div>
    <mat-divider/>
    <div class="loren-filters-actions">
        <button matButton="filled" (click)="clearSelection()" class="btn-secondary">
            {{ "alarms.clear" | transloco }}
        </button>
        <button matButton="filled" (click)="selectionSubmitted.emit(selectionMap)">
            {{ "alarms.save" | transloco }}
        </button>
    </div>
</div>
